"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _index = require("../index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PermissionCheckboxInput = function PermissionCheckboxInput(props) {
  var field = props.field,
    form = props.form,
    label = props.label,
    labelNotBold = props.labelNotBold,
    showErrorImmediately = props.showErrorImmediately;
  var error = form.errors[field.name];
  var showError = !!(error && (form.submitCount > 0 || showErrorImmediately));
  var additionalProps = {};
  var pData = _index.permissionsData.find(function (p) {
    return "['".concat(p.permission, "']") === field.name;
  });
  var triggeringPermissions = _index.permissionsData.filter(function (p) {
    return p.toggleFieldAliasesWhenSet && p.toggleFieldAliasesWhenSet.includes(pData.alias);
  });
  var isDisabled = triggeringPermissions.some(function (tPerm) {
    return form.values[tPerm.permission];
  });
  (0, _react.useEffect)(function () {
    if (isDisabled && !field.value) {
      form.setFieldValue(field.name, true);
    }
  }, [isDisabled, field.value]);
  function onChange() {
    var localOnChange = field.onChange;
    if (pData.toggleFieldAliasesWhenSet) {
      localOnChange = function localOnChange() {
        if (field.value === false) {
          // Toggle on and toggle aliased fields on, too
          form.setFieldValue(field.name, true);
          pData.toggleFieldAliasesWhenSet.forEach(function (alias) {
            var pDataFromAlias = _index.permissionsData.find(function (p) {
              return p.alias === alias;
            });
            var aliasFormikName = "['".concat(pDataFromAlias.permission, "']");
            form.setFieldValue(aliasFormikName, true);
          });
          return;
        }

        // Toggle off and reset to initial values
        form.setFieldValue(field.name, false);
        pData.toggleFieldAliasesWhenSet.forEach(function (alias) {
          var pDataFromAlias = _index.permissionsData.find(function (p) {
            return p.alias === alias;
          });
          var aliasFormikName = "['".concat(pDataFromAlias.permission, "']");
          form.setFieldValue(aliasFormikName, form.initialValues[pDataFromAlias.permission]);
        });
      };
    }
    return localOnChange;
  }

  /* ////////////////////////////////////////////////////////////////////////
  // RENDER ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'form-group ' + (showError ? 'has-error' : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label",
    style: labelNotBold && {
      fontWeight: 'normal'
    }
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, additionalProps, (0, _omit2["default"])(field, ['onChange']), {
    checked: field.value || false,
    disabled: isDisabled,
    onChange: onChange(),
    type: "checkbox"
  })), "\xA0\xA0", label), showError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "help-block"
  }, error));
};
PermissionCheckboxInput.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  label: _propTypes["default"].node,
  labelNotBold: _propTypes["default"].bool,
  showErrorImmediately: _propTypes["default"].bool
};
var _default = PermissionCheckboxInput;
exports["default"] = _default;